/* eslint-disable */
// @ts-nocheck
import * as React from 'react';
import { Tooltip as ReactTippyTooltip } from 'react-tippy';
import classNames from 'classnames';
const DEFAULT_TITLE = ' ';
// for all property options, see: https://github.com/tvkhoa/react-tippy
// Most commonly needed: what to display in the body of the tooltip:
//    title: if you're just passing a string
//    html: if you're passing in a component not just a string
// NOTE: you can also pass in 'body' as a prop, either string or component,
// and we will convert to 'title' or 'html' to pass through to ReactTippyTooltip/
type Props = {
  // to allow greater flexibility of implementation, this component can take
  // either a string or component as the body, and we do the logic here to
  // convert to either 'title' or 'html' to pass along to ReactTippyTooltip
  body?: string | React.ReactElement<any>;
  hide?: boolean;
  // set to 'true' if you want tooltip to be positioned in the
  // upper right corner of the container it's in
  upperRight?: boolean;
  className?: string;
  infoIconClassName?: string;
  // if no children are passed in we display the 'i' info icon by default
  children?: React.ReactNode;
  title?: string;
};

class Tooltip extends React.PureComponent<Props> {
  renderInfoIcon = () => {
    const { infoIconClassName, upperRight } = this.props;
    return (
      <i
        className={classNames('material-icons tooltip-icon', infoIconClassName, {
          'h_va-u': upperRight,
        })}
      >
        info_outline
      </i>
    );
  };

  _generateNecessaryProperties = () => {
    const { body, title } = this.props;

    if (typeof title === 'string') {
      return {
        title: '',
        html: <span>{title}</span>,
      };
    }

    if (typeof body === 'string') {
      return {
        html: <span>{body}</span>,
      };
    }

    if (body) {
      return {
        html: body,
      };
    }

    // If html == null at least title must be set.
    return {
      title: DEFAULT_TITLE,
    };
  };

  render() {
    const { hide, upperRight } = this.props;
    const defaults = {
      theme: 'light',
      arrow: true,
      interactive: true,
    };
    const properties = {
      ...defaults,
      ...this.props,
      ...this._generateNecessaryProperties(),
      popperOptions: {
        modifiers: {
          preventOverflow: {
            enabled: false,
          },
        },
      },
    };
    properties.className = classNames(this.props.className, {
      'tooltip-info-icon-container': !this.props.children,
      'upper-right-corner': upperRight,
    });

    if (hide) {
      return null;
    }

    return <ReactTippyTooltip {...properties}>{this.props.children || this.renderInfoIcon()}</ReactTippyTooltip>;
  }
}

export default Tooltip;
